"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "size", "lazy", "altText", "borderRadius", "src"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as _c } from "react/compiler-runtime";
import { Box } from '@autoguru/overdrive';
import * as styles from './Avatar.css';
import { LazyPicture, Picture } from '@autoguru/picture';
import { jsx as _jsx } from "react/jsx-runtime";
export const Avatar = t0 => {
  const $ = _c(25);
  let className;
  let rest;
  let src;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      className,
      size: t1,
      lazy: t2,
      altText: t3,
      borderRadius: t4,
      src
    } = _t);
    rest = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = src;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    className = $[1];
    rest = $[2];
    src = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const size = t1 === undefined ? 40 : t1;
  const lazy = t2 === undefined ? true : t2;
  const altText = t3 === undefined ? "avatar image" : t3;
  const borderRadius = t4 === undefined ? "full" : t4;
  const t5 = src;
  let t6;
  if ($[8] !== altText || $[9] !== rest || $[10] !== size || $[11] !== t5) {
    t6 = _objectSpread({
      src: t5,
      width: size,
      height: size,
      aspectRatio: 1,
      objectFit: "cover",
      altText
    }, rest);
    $[8] = altText;
    $[9] = rest;
    $[10] = size;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const pictureProps = t6;
  let t7;
  if ($[13] !== className) {
    t7 = [className, styles.root];
    $[13] = className;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== size) {
    t8 = {
      width: size,
      height: size
    };
    $[15] = size;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== lazy || $[18] !== pictureProps) {
    t9 = lazy ? /*#__PURE__*/_jsx(LazyPicture, _objectSpread({}, pictureProps)) : /*#__PURE__*/_jsx(Picture, _objectSpread({}, pictureProps));
    $[17] = lazy;
    $[18] = pictureProps;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== borderRadius || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = /*#__PURE__*/_jsx(Box, {
      borderRadius: borderRadius,
      overflow: "hidden",
      flexShrink: 0,
      className: t7,
      style: t8,
      children: t9
    });
    $[20] = borderRadius;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};